export default __webpack_public_path__ + "static/media/gauge-fair.0d2a6824.png";